export default __webpack_public_path__ + "static/img-app-training-11f2d78b1c84f8d3919e82b6c167f912.webp";